import { j as a } from "../../../jsx-runtime-B6kdoens.js";
import { c as e, f as m } from "../../../create-component-CBAeEoQ6.js";
import { Card as s } from "../index.js";
const p = e(
  "MediaCard",
  m(({ children: r, ...o }, t) => /* @__PURE__ */ a.jsx(s, { ref: t, ...o, children: r }))
);
export {
  p as MediaCard
};
//# sourceMappingURL=index.js.map
